import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
    Button,
    DataForm,
    DataSelect,
    DateTimePicker,
    TextBox,
    TypeSelect
} from '../../components/Form';
import {
    Grid,
    GridColumn,
    LeftComponents,
} from '../../components/Layout';


import { postData } from '../../Api';
import {
    PanelBox,
    Title,
} from '../../components/Display';

export default function TaroffTransactionsNew(props) {
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [modal, setModal] = useState(null);
    const allProps = { ...props, ...Object.fromEntries(searchParams.entries()) };
    const [formShopId, setFormShopId] = useState(null);
    const [formShopIdOptions, setFormShopIdOptions] = useState([]);
    useEffect(() => {
        postData('/api/panel/page/taroff-transactions-new/select-data/shop-id').then((response) => {
            setFormShopIdOptions(response.data);
        });
    }, []);
    const [formType, setFormType] = useState(null);
    const [formTitle, setFormTitle] = useState(null);
    const [formAmount, setFormAmount] = useState(null);
    const [formDescription, setFormDescription] = useState(null);
    const [formCreateTime, setFormCreateTime] = useState(null);
    const handlecomp1 = async () => {
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    const handlecomp2 = async () => {
        await postData('/api/panel/page/taroff-transactions-new/save-data', {
            shop_id: formShopId,
            type: formType,
            title: formTitle,
            amount: formAmount,
            description: formDescription,
            create_time: formCreateTime,
        });
        props.onDismiss ? props.onDismiss() : navigate(-1);
    };
    return (
        <PanelBox>
            <DataForm>
                <Title>ایجاد تراکنش های تعارف</Title>
                <Grid>
                    <GridColumn width={12}>
                        <DataSelect
                            label={'فروشگاه'}
                            options={formShopIdOptions}
                            value={formShopId}
                            onChange={setFormShopId}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TypeSelect label={'نوع'} value={formType} onChange={setFormType} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'عنوان'} value={formTitle} onChange={setFormTitle} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox label={'مبلغ'} value={formAmount} onChange={setFormAmount} />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <DateTimePicker
                            label={'زمان ایجاد'}
                            value={formCreateTime}
                            onChange={setFormCreateTime}
                        />
                    </GridColumn>
                </Grid>
                <Grid>
                    <GridColumn width={12}>
                        <TextBox
                            label={'شرح'}
                            value={formDescription}
                            onChange={setFormDescription}
                        />
                    </GridColumn>
                </Grid>
                <LeftComponents>
                    <Button onClick={handlecomp1}>انصراف</Button>
                    <Button onClick={handlecomp2}>ذخیره</Button>
                </LeftComponents>
            </DataForm>
            {modal && modal}
        </PanelBox>
    );
}
